import { render, staticRenderFns } from "./LendioPage.vue?vue&type=template&id=12338c8a&scoped=true"
import script from "./LendioPage.vue?vue&type=script&lang=ts"
export * from "./LendioPage.vue?vue&type=script&lang=ts"
import style0 from "./LendioPage.vue?vue&type=style&index=0&id=12338c8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12338c8a",
  null
  
)

export default component.exports